import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";

import HomePage from './components/Pages/HomePage/HomePage';
import MenuPage from './components/Pages/MenuPage/MenuPage';
import AboutPage from './components/Pages/AboutPage/AboutPage';
import ContactPage from './components/Pages/ContactPage/ContactPage';
import ReservationPage from './components/Pages/ReservationPage/ReservationPage';

// export const url = `http://192.168.31.137:80`;
// export const url = `http://192.168.0.132:80`;
export const url = `https://api.le-sonarga.com`;

function App() {  
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/reservation" element={<ReservationPage />} />
        <Route path="/menu" element={<MenuPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
